import {
    ConfigitAceItem,
    ConfigitAceVariableIntervalValue,
    ConfigitAceVariableSingletonValue,
    ConfigitAceVariableValue,
} from './configit-ace.model';
import moment from 'moment/moment';

const dateFormat = 'DD.MM.YYYY';

export function isVisible({ properties }: ConfigitAceItem): boolean {
    return properties.find((p) => p.id === 'SHOW')?.value === true;
}

export function singletonValues(values: ConfigitAceVariableValue[]) {
    return <ConfigitAceVariableSingletonValue[]>values.filter((v) => v.type === 'SingletonValue');
}

export function intervalValues(values: ConfigitAceVariableValue[]) {
    return <ConfigitAceVariableIntervalValue[]>values.filter((v) => v.type === 'IntervalValue');
}

export function toIsoDate(value: string): string {
    if (value) {
        const parsed = moment(value, dateFormat).utcOffset(0, true);
        return parsed?.toISOString();
    }
}
export function fromIsoDate(value: string) {
    const date = moment(value);
    return date?.format(dateFormat);
}
